<script setup>
import { ref, defineEmits, getCurrentInstance } from "vue";
import CryptoJS from 'crypto-js';

const duration = ref(30);
const userId = ref(1001);
const roomId = ref('')
const generatedUrl = ref('');
const showPopup = ref(false);
const APP_ID = ref('');

const emit = defineEmits(["close"]);
const { appContext } = getCurrentInstance();
APP_ID.value = appContext.config.globalProperties.$APP_ID;

const generateLink = async () => {
  // Send the userId to the server and fetch the data
  try {
    const secretId = appContext.config.globalProperties.$USER.secretId;
    const secretKey = appContext.config.globalProperties.$USER.secretKey;
    roomId.value = appContext.config.globalProperties.$USER.roomId;
    const url = "/api/room/" + roomId.value + "?secret_id=" + secretId + "&secret_key=" + secretKey + "&user_id=" + userId.value + "&expiration=" + (duration.value * 60);
    console.log(url)
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Failed to fetch data');
    }
    const data = await response.json();
    const appId = APP_ID.value;
    const token = `${roomId.value}:${userId.value}:${data.rtc_token}:${data.rtm_token}:${appId}:0`;
    const encryptionKey = 'mm'
    const encryptedToken = btoa(CryptoJS.AES.encrypt(token, encryptionKey).toString())
    generatedUrl.value = `https://remote-manipulator.netlify.app/${encryptedToken}`;

    showPopup.value = true;

  } catch (error) {
    console.error("Error fetching data:", error);
    alert("Failed to retrieve data from server.");
  }
};

const copyUrl = async () => {
  try {
    await navigator.clipboard.writeText(generatedUrl.value);
    alert("URL copied to clipboard!");
  } catch (err) {
    alert("Failed to copy URL!");
  }
};

const closeGenerator = () => {
  generatedUrl.value = "";
  showPopup.value = false;
  emit("close");
};
</script>

<template>
  <div class="d-flex justify-content-center align-items-center vh-100">
    <div class="modal-dialog modal-dialog-centered w-25">
      <div class="modal-content bg-dark text-light p-4">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Generate One-Time Link</h5>
        </div>
        <div class="modal-body mt-2">

          <div class="d-flex align-items-center">
            <label for="roomId" class="form-label mb-0 me-2" style="width: 30%;">Duration</label>
            <input type="number" v-model="duration" min="1" max="60" class="form-control" placeholder="Minutes">
          </div>

        </div>
        <div class="modal-footer mt-2">
          <button class="btn btn-primary" @click="() => generateLink()">OK</button>
        </div>
      </div>
    </div>
  </div>

  <div v-if="showPopup" class="modal fade show d-block" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content bg-dark text-light p-4">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">Your Generated Link</h5>
          <button type="button" class="btn-close" @click="closeGenerator"></button>
        </div>
        <div class="modal-body">
          <div class="d-flex align-items-center justify-content-start mb-2">
            <p class="mb-0 me-2"><strong>Room:</strong></p>
            <p class="mb-0">{{ roomId }}</p>
          </div>

          <div class="d-flex align-items-center justify-content-start">
            <p class="mb-0 me-2"><strong>Link:</strong></p>
            <input
              type="text"
              class="form-control bg-secondary text-white w-75"
              :value="generatedUrl"
              readonly
            />
            <button class="btn btn-primary ms-2" @click="copyUrl">Copy</button>
          </div>

        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeGenerator">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
